import { SVGIconComponent } from './types';

export const AccessControl: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="project-type/access" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M14.2069414,6.35256475 L14.2069414,5.29360145 C14.2069414,2.37503281 11.8317307,1.77635684e-15 8.91240501,1.77635684e-15 C5.99307932,1.77635684e-15 3.61786857,2.37527583 3.61786857,5.29360145 L3.61786857,6.35256475 C2.44820506,6.35256475 1.5,7.30076879 1.5,8.47049135 L1.5,15.8820734 C1.50105464,17.051769 2.44923108,18 3.61786857,18 L14.2061314,18 C15.3757949,18 16.324,17.051796 16.324,15.8820734 L16.324,8.47049135 C16.324,7.30079579 15.3758219,6.35256475 14.2072114,6.35256475 L14.2069414,6.35256475 Z M5.73552114,5.29360145 C5.73552114,3.54167723 7.16042079,2.11663054 8.91240501,2.11663054 C10.6643892,2.11663054 12.0892889,3.54156922 12.0892889,5.29360145 L12.0892889,6.35256475 L5.73579115,6.35256475 L5.73552114,5.29360145 Z M9.9713663,12.7062635 C9.9713663,13.2905983 9.49780378,13.7652268 8.91243201,13.7652268 C8.32811326,13.7652268 7.85349772,13.2916514 7.85349772,12.7062635 L7.85349772,10.5883369 C7.85349772,10.0040022 8.32811326,9.52937365 8.91243201,9.52937365 C9.49675075,9.52937365 9.9713663,10.0029491 9.9713663,10.5883369 L9.9713663,12.7062635 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
